import React from "react";
import QuizLoader from "../Quiz/Components/QuizLoader";
import ThemeFactory from "../Shared/Theme/ThemeFactory";

export default function BrandsQuiz() {
    return <QuizLoader
        url="brandsQuiz"
        theme={ThemeFactory.withDirectory("polish-brands-quiz")}
    />
}